<template>
  <div class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast />
        <Toolbar class="p-mb-4">
          <template v-slot:left>
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="p-button-success p-mr-2 p-mb*2"
              @click="openNew"
            />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="crachas"
          class="p-datatable-sm"
          v-model:selection="selectedCrachas"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} crachas"
        >
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">Crachás</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global']"
                  placeholder="Pesquisar..."
                />
              </span>
            </div>
          </template>
          <Column field="nome" header="Cracha" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Cracha:</span>
              {{ slotProps.data.nome }}
            </template>
          </Column>
          <Column field="referencia" header="Referência" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Referência:</span>
              {{ slotProps.data.referencia }}
            </template>
          </Column>
          <Column field="andar" header="Andar" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Andar:</span>
              {{ slotProps.data.andar }}
            </template>
          </Column>
          <Column field="status" header="Status" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Status:</span>
              <span
                v-if="slotProps.data.status === true"
                :class="'product-badge status-' + slotProps.data.status"
                >Indisponível</span
              >
              <span
                v-if="slotProps.data.status === false"
                :class="'product-badge status-' + slotProps.data.status"
                >Disponível</span
              >
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success p-mr-2"
                @click="editCracha(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDeleteCracha(slotProps.data)"
              />
            </template>
          </Column>
          <template #empty>
            <div class="p-text-center">Nenhum registro encontrado</div>
          </template>
        </DataTable>

        <Dialog
          v-model:visible="crachaDialog"
          :style="{ width: '480px' }"
          :header="titleDialog"
          :modal="true"
          class="p-fluid"
        >
          <div class="p-field">
            <label for="nome">Nome do Cracha</label>
            <InputText
              id="nome"
              v-model.trim="cracha.nome"
              required="true"
              type="text"
              placeholder="Digite o nome do cracha"
              autofocus
              :class="{ 'p-invalid': submitted && !cracha.nome }"
            />
            <small class="p-invalid" v-if="submitted && !cracha.nome"
              >Nome é obrigatório.</small
            >
          </div>

          <div class="p-field">
            <label for="referencia">Referência</label>
            <InputNumber
              id="referencia"
              mode="decimal"
              :useGrouping="false"
              v-model="cracha.referencia"
              placeholder="Digite o referência do cracha"
              :class="{ 'p-invalid': submitted && !cracha.referencia }"
            />
            <small class="p-invalid" v-if="submitted && !cracha.referencia"
              >Referência é obrigatório</small
            >
          </div>
          <div class="p-field">
            <label for="andar">Andar</label>
            <InputText
              id="andar"
              v-model.trim="cracha.andar"
              required="true"
              placeholder="Digite o andar do cracha"
              maxlength="50"
              :class="{ 'p-invalid': submitted && !cracha.andar }"
            />
            <small class="p-invalid" v-if="submitted && !cracha.andar"
              >Andar é obrigatório</small
            >
          </div>
          <template #footer>
            <Button
              label="Salvar"
              icon="pi pi-check"
              class="p-button-raised"
              @click="sendCracha"
            />
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-raised p-button-text"
              @click="hideDialog"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteCrachaDialog"
          :style="{ width: '450px' }"
          header="Mensagem de Confirmação!"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="cracha"
              >Tem certeza de que deseja excluir o registro
              <b>{{ cracha.referencia }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="Sim"
              icon="pi pi-check"
              class="p-button-raised"
              @click="deletecracha"
            />
            <Button
              label="Não"
              icon="pi pi-times"
              class="p-button-raised p-button-text"
              @click="deleteCrachaDialog = false"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteCrachasDialog"
          :style="{ width: '450px' }"
          header="Mensagem de Confirmação!"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="cracha"
              >Tem certeza de que deseja excluir os registros selecionados
              ?</span
            >
          </div>
          <template #footer>
            <Button
              label="Sim"
              icon="pi pi-check"
              class="p-button-raised"
              @click="deleteSelectedCrachas"
            />
            <Button
              label="Não"
              icon="pi pi-times"
              class="p-button-raised p-button-text"
              @click="deleteCrachasDialog = false"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@/service/Auth/AuthService";
import CrachaService from "@/service/Cracha/CrachaService";
export default {
  data() {
    return {
      crachas: null,
      crachaDialog: false,
      deleteCrachaDialog: false,
      deleteCrachasDialog: false,
      cracha: {
        id: null,
        nome: null,
        referencia: null,
        andar: null,
        status: true,
      },
      selectedCrachas: null,
      filters: {},
      submitted: false,
      titleDialog: null,
      msg: null,
      msgUsuario: null,
      msgDesenvolvedor: null,
    };
  },
  crachaService: null,
  authService: null,
  created() {
    this.authService = new AuthService();
    this.crachaService = new CrachaService();
  },
  mounted() {
    this.authService.checarToken(this.listarCrachas());
  },
  methods: {
    listarCrachas() {
      this.crachaService.listar().then((data) => {
        this.crachas = data;
      });
    },
    openNew() {
      this.titleDialog = "Novo cracha";
      this.submitted = false;
      this.crachaDialog = true;
    },
    hideDialog() {
      this.crachaDialog = false;
      this.submitted = false;
      this.cracha = {};
    },
    sendCracha() {
      this.authService.checarToken(this.saveCracha());
    },
    saveCracha() {
      this.submitted = true;
      if (this.cracha.id == null) {
        this.crachaService
          .criar(this.cracha)
          .then((data) => {
            if (data.status === 201) {
              this.$toast.add({
                severity: "success",
                summary: "Sucesso",
                detail: "Registro salvo com sucesso!",
              });
              this.crachas.push(data.data);
              this.hideDialog();
            }
          })
          .catch((error) => {
            this.msgUsuario = error.response.data[0].mensagemUsuario;
            this.msgDesenvolvedor =
              error.response.data[0].mensagemDesenvolvedor;
            console.log(this.msgDesenvolvedor);
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: this.msgUsuario,
            });
          });
      } else {
        this.crachaService
          .atualizar(this.cracha.id, this.cracha)
          .then((data) => {
            if (data.status === 200) {
              this.$toast.add({
                severity: "success",
                summary: "Sucesso",
                detail: "Registro atualizado com sucesso!",
              });
              this.hideDialog();
            }
          });
      }
    },
    editCracha(cracha) {
      this.cracha = cracha;
      this.titleDialog = this.cracha.referencia;
      this.crachaDialog = true;
    },
    confirmDeleteCracha(cracha) {
      this.cracha = cracha;
      this.deleteCrachaDialog = true;
    },
    deleteCracha() {
      this.authService.checarToken(this.deletarCracha());
    },
    deletarCracha() {
      this.crachaService.remover(this.cracha.id).then((data) => {
        if (data.status === 204) {
          this.deleteCrachaDialog = false;
          this.cracha = {};
          this.$toast.add({
            severity: "success",
            summary: "Sucesso!",
            detail: "Registro Deletado.",
            life: 3000,
          });
          this.listarCrachas();
        } else {
          console.log(data);
          this.$toast.add({
            severity: "erro",
            summary: "Erro!",
            detail: "Erro ao deletar registro.",
            life: 3000,
          });
        }
      });
    },
    confirmDeleteSelected() {
      this.deleteCrachasDialog = true;
    },
    deleteSelectedCrachas() {
      for (var i in this.selectedCrachas) {
        this.cracha = this.selectedCrachas[i];
        this.deleteCracha();
      }
      this.deleteCrachasDialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
.img-fluid {
  max-width: 100%;
  height: auto;
}
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cracha-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.p-dialog .cracha-image {
  width: 150px;
  margin: 0 auto 2rem auto;
  display: block;
}
.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cracha-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
.p-datatable-sm .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
@media screen and (max-width: 40em) {
  ::v-deep(.p-datatable) {
    &.p-datatable-sm {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;
        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }
        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: right;
        }
        .p-rating {
          display: inline-block;
        }
      }
    }
  }
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-true {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-false {
    background: #c8e6c9;
    color: #256029;
  }
}
</style>